import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import BgParallax from '../../components/bg-parallax'
import PricingThree from '../../components/pricing-three'
import ClientThree from '../../components/client-three'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/lawyer/bg.jpg'
import aboutImg from '../../assets/images/lawyer/01.jpg'
import cta from '../../assets/images/lawyer/bg02.jpg'

import { lawyerCate, lawyerCounter, lawyerServices, lawyerTeam } from '../../data/data'
import CountUp from 'react-countup'

export default function IndexLawyer() {
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-home d-flex align-items-center pb-0" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay" style={{opacity: '0.7'}}></div>
      <div className="container">
          <div className="row justify-content-center align-items-center mt-5">
              <div className="col-lg-7 col-md-7">
                  <div className="title-heading text-center mt-4">
                      <h1 className="heading text-white title-dark fw-bold display-4 mb-3">Lawyer will always be there for your justice.</h1>
                      <p className="para-desc mx-auto title-dark text-light">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="/contact" className="btn btn-primary mb-2 me-2">Know More</Link>
                          <Link to="/contact" className="btn btn-outline-primary mb-2 me-2"> Hire Me</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow-lg rounded" alt=""/>
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h4 className="title mb-4">More Justice Debtors</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <Link to="#" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {lawyerServices.map((item,index)=>{
              let Icon = item.icon
              return(
                <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="card border-0 shadow rounded-3 text-center p-4 py-4">
                        <div className="content">
                            <Icon className={item.color}></Icon>
                            <h4 className="title mt-3">{item.title}</h4>
                            <p className="text-muted">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section position-relative">
    <BgParallax bg={cta}/>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row" id="counter">
            {lawyerCounter.map((item,index)=>{
              return(
                  <div className="col-md-3 col-6" key={index}>
                      <div className="counter-box py-4 text-center">
                          <i className={`${item.icon} text-light title-dark mdi-48px`}></i>
                          <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={item.value}/>+</h2>
                          <h6 className="counter-head text-light title-dark">{item.title}</h6>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Lawyers Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {lawyerTeam.map((item,index)=>{
              return(
                <div className="col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="team-list position-relative overflow-hidden shadow rounded">
                        <img src={item.image} className={item.imgClass} alt=""/>
                        <div className={item.class}>
                            <h5 className="title mb-0">{item.name}</h5>
                            <small className="text-muted">{item.position}</small>
                            <p className="text-muted mt-3">{item.desc}.</p>
                            <ul className="list-unstyled follow social-icon social mb-0">
                                {item.social.map((el,index)=>{
                                  return(
                                    <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={el}></i></Link></li>
                                  )
                                })}
                            </ul>
                        </div>
                    </div>                        
                </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Categories</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

            <div className="row">
              {lawyerCate.map((item,index)=>{
                return(
                    <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                        <div className="feature p-3 py-4 rounded">
                            <i className={`${item.icon} text-primary float-start me-3 mt-2 h1`}></i>
                            <div className="content d-block overflow-hidden">
                                <h4 className="title">{item.title}</h4>
                                <p className="text-muted mt-2">{item.desc}</p>
                                <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                            </div>
                        </div>
                    </div>
                )
              })}
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="title mb-4">Pricing Table</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

         <PricingThree/>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container mt-60">
          <div className="row">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="title mb-4">Review From Customer's</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-10 mt-4 pt-2">
                  <ClientThree/>
              </div>
          </div>
      </div>
    </section>

    <Footer/>

    </>
  )
}
